import React, { useContext } from "react";
import Heading from "@amzn/meridian/heading";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Tooltip from "@amzn/meridian/tooltip";
import { OverviewContext } from "../overview/context/OverviewContext";
import { FormattedMessage, injectIntl } from "react-intl";
import Box from "@amzn/meridian/box";
import infoKnockoutTokens from "@amzn/meridian-tokens/base/icon/info-knockout";
import Icon from "@amzn/meridian/icon";
import { SORT, INDUCT } from "../overview/utils/Constants";
import { STRINGS } from "../outboundAmzl/util/Constants";

const HCView = (props) => {
  const { viewModel } = useContext(OverviewContext);

  const isActualsAlert = (processName) => {
    return processName !== INDUCT;
  };

  return (
    <Box type="outline" spacingInset="400">
      <div>
        <div className="overview-hc">
          <Heading level={2} type="h300" alignment="left">
            <FormattedMessage
              id={viewModel.hc[props.hc.processName].title}
              defaultMessage={viewModel.hc[props.hc.processName].defaultMessage}
            />
            <Tooltip
              position="right"
              title={props.intl.formatMessage({
                id: viewModel.hc[props.hc.processName].tooltip,
                defaultMessage:
                  viewModel.hc[props.hc.processName].tooltipMessage,
              })}
            >
              <Icon className={"custom-tool-tip"} tokens={infoKnockoutTokens} />
            </Tooltip>
          </Heading>
        </div>
        <Row width="100%" widths={["grid-6", "grid-6"]}>
          <div>
            <Text type="b100">
              <FormattedMessage id="hc.planned" defaultMessage="Planned" />
            </Text>
            {props.hc.processName === INDUCT ? (
              <Text type="d50">{14}</Text>
            ) : (
              STRINGS.EMPTY
            )}
            {props.hc.processName === SORT ? (
              <Text type="d50">{"36/12"}</Text>
            ) : (
              STRINGS.EMPTY
            )}
          </div>
          <div>
            <Text type="b100">
              <FormattedMessage id="fph.actual" defaultMessage="Actual" />
            </Text>
            {isActualsAlert(props.hc.processName) ? (
              <Text type="d50" className="alert">
                {viewModel.hc[props.hc.processName].actual}
              </Text>
            ) : (
              <Text type="d50">
                {viewModel.hc[props.hc.processName].actual}
              </Text>
            )}
          </div>
        </Row>
      </div>
    </Box>
  );
};

export default injectIntl(HCView);



// WEBPACK FOOTER //
// ./src/components/HC/HCView.js